module.exports = __webpack_public_path__ + "static/media/STEP4.208cf85d.png";